import instance from '../instance'
export default class Vendors {
  static getMany(params = {}) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/spreadsheet-aggregate/itemNo`,
      method: 'GET',
      params: params
    })
  }

  static create(params = {}) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/spreadsheet-aggregate/itemNo`,
      method: 'POST',
      params: params
    })
  }

  static update(params = {}) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/spreadsheet-aggregate/itemNo`,
      method: 'PUT',
      params
    })
  }

  static delete(params = []) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/spreadsheet-aggregate/itemNo`,
      method: 'DELETE',
      params
    })
  }

  static get(id) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/spreadsheet-aggregate/itemNo/${id}`,
      method: 'GET'
    })
  }

  static addMany(form) {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/spreadsheet-aggregate/item-number/import`,
      method: 'POST',
      data: form
    })
  }
}
